var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainNav"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":"https://gcdn.bionluk.com/site/general/bionluk_logo_gk.png"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }